import React from 'react';

const CarHire = () => {
  const carTypes = [
    {
      id: 1,
      name: 'Economy Car',
      price: '$30/day',
      features: ['AC', 'Manual', '4 Seats', 'Fuel Efficient'],
      image: '🚗'
    },
    {
      id: 2,
      name: 'Compact Car',
      price: '$40/day',
      features: ['AC', 'Automatic', '4 Seats', 'Compact Size'],
      image: '🚙'
    },
    {
      id: 3,
      name: 'SUV',
      price: '$60/day',
      features: ['AC', 'Automatic', '7 Seats', 'All Wheel Drive'],
      image: '🚐'
    },
    {
      id: 4,
      name: 'Luxury Car',
      price: '$100/day',
      features: ['AC', 'Automatic', '5 Seats', 'Premium Features'],
      image: '🏎️'
    }
  ];

  const handleBookNow = (carName) => {
    // In a real app, this would navigate to booking page
    alert(`Booking ${carName} - This would open the booking form`);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>XGO Car Hire Services</h1>
        <p style={styles.subtitle}>Find the perfect vehicle for your journey</p>
      </div>

      <div style={styles.carGrid}>
        {carTypes.map(car => (
          <div key={car.id} style={styles.carCard}>
            <div style={styles.carImage}>{car.image}</div>
            <h3 style={styles.carName}>{car.name}</h3>
            <p style={styles.carPrice}>{car.price}</p>
            <ul style={styles.featuresList}>
              {car.features.map((feature, index) => (
                <li key={index} style={styles.featureItem}>{feature}</li>
              ))}
            </ul>
            <button 
              style={styles.bookButton}
              onClick={() => handleBookNow(car.name)}
            >
              Book Now
            </button>
          </div>
        ))}
      </div>

      <div style={styles.infoSection}>
        <h2 style={styles.sectionTitle}>Why Choose XGO Car Hire?</h2>
        <div style={styles.benefits}>
          <div style={styles.benefit}>
            <h3>🔒 Insurance Included</h3>
            <p>Comprehensive insurance coverage for all rentals</p>
          </div>
          <div style={styles.benefit}>
            <h3>📍 Multiple Locations</h3>
            <p>Pick-up and drop-off at convenient locations</p>
          </div>
          <div style={styles.benefit}>
            <h3>⏰ 24/7 Support</h3>
            <p>Round-the-clock customer assistance</p>
          </div>
        </div>
      </div>

      <div style={styles.contactSection}>
        <h2 style={styles.sectionTitle}>Need Help?</h2>
        <p>Call us: +260 123 456 789</p>
        <p>Email: carhire@xgo.com</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    backgroundColor: '#f8f9fa'
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    backgroundColor: '#007bff',
    color: 'white',
    padding: '30px',
    borderRadius: '10px'
  },
  title: {
    fontSize: '2.5rem',
    margin: '0',
    marginBottom: '10px'
  },
  subtitle: {
    fontSize: '1.2rem',
    margin: '0',
    opacity: 0.9
  },
  carGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
    marginBottom: '40px'
  },
  carCard: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    textAlign: 'center',
    transition: 'transform 0.3s ease'
  },
  carImage: {
    fontSize: '4rem',
    marginBottom: '15px'
  },
  carName: {
    fontSize: '1.5rem',
    margin: '0 0 10px 0',
    color: '#333'
  },
  carPrice: {
    fontSize: '1.2rem',
    color: '#007bff',
    fontWeight: 'bold',
    margin: '0 0 15px 0'
  },
  featuresList: {
    listStyle: 'none',
    padding: '0',
    margin: '0 0 20px 0'
  },
  featureItem: {
    backgroundColor: '#f8f9fa',
    margin: '5px 0',
    padding: '5px 10px',
    borderRadius: '5px',
    fontSize: '0.9rem'
  },
  bookButton: {
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease'
  },
  infoSection: {
    marginBottom: '40px'
  },
  sectionTitle: {
    textAlign: 'center',
    fontSize: '2rem',
    marginBottom: '30px',
    color: '#333'
  },
  benefits: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px'
  },
  benefit: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    textAlign: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  },
  benefit: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    textAlign: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  },
  contactSection: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '10px',
    textAlign: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  }
};

export default CarHire;
